import { constants } from 'app/client/store/reducers/app';
import isUnlocked from 'app/client/utilities/isUnlocked';

const mapStateToProps = ({ user, app, otp }) => {
  const authenticated = user.id !== null;
  const unlocked = authenticated && isUnlocked(otp);

  return {
    authenticated,
    unlocked,
    language: app.language,
    customer:
      authenticated && unlocked && app.validCustomer && app.customer !== null
        ? app.customer
        : false,
    redirectTo: app.redirectTo,
    theme: app.theme,
    autoSwitchTheme: app.autoSwitchTheme,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setTheme: (payload) =>
    dispatch({
      type: constants.setTheme,
      payload,
    }),
  clearRedirect: () => dispatch({ type: constants.clearRedirect }),
});

export default [mapStateToProps, mapDispatchToProps];
